import * as Rollbar from "rollbar";

export interface IRollBar {
  critical(message: string, data?: any): void;
  error(message: string, data?: any): void;
  warning(message: string): void;
  info(message: string, data?: any): void;
  debug(message: string, data?: any): void;
}
// TODO: Replace with Rollbar verbose & send config flags
let rollBar: IRollBar = {
  critical: (message: string, data?: any) => {
    console.error(`Dev rollbar critical: ${message}`);
  },
  error: (message: string, data?: any) => {
    console.error(`Dev rollbar error: ${message}`);
  },
  warning: (message: string, data?: any) => {
    console.warn(`Dev rollbar warning: ${message}`);
  },
  info: (message: string, data?: any) => {
    console.info(`Dev rollbar info: ${message}`, data);
  },
  debug: (message: string, data?: any) => {
    console.debug(`Dev rollbar debug: ${message}`);
  }
};

if (process.env.NODE_ENV === "production") {
  rollBar = new (Rollbar as any)({
    accessToken: "245c3db65b0a446ea02cb50588037286",
    captureUncaught: false, // Temporarily reduce verbosity until app is cleaned up
    captureUnhandledRejections: false, // Temporarily reduce verbosity until app is cleaned up
    verbose: true,
    payload: {
      environment: process.env.NODE_ENV
    }
  });
}

export default rollBar;



// WEBPACK FOOTER //
// ./src/utils/rollbar.ts